import { useEffect, useState } from 'react'

const useScrolledPast = (el: HTMLElement | null) => {
  const [hasScrolledPast, setHasScrolledPast] = useState<boolean>()

  useEffect(() => {
    let handleScroll

    if (el) {
      handleScroll = () => {
        setHasScrolledPast(el.getBoundingClientRect().top < 0)
      }
      document.addEventListener('scroll', handleScroll, true)
      handleScroll()
    }

    return () => {
      if (handleScroll) document.removeEventListener('scroll', handleScroll, true)
    }
  }, [el])

  return hasScrolledPast
}

export default useScrolledPast
